<template>
  <div ref="test_to_take" class="test-to-take">
    <h2 class="mb-3">{{ $t('testToTake') }}</h2>
    <p>{{ $t('chooseProvider') }}</p>
    <div class="markets-container">
      <div @click="setCurrentVendor(vendor)" v-for="(vendor, i) in vendors" :key="i"
        :class="'market-card ' + (currentVendor == vendor ? 'selected' : '')">
        <img width="100" :src="vendor.logoUrl" alt="logo">
      </div>
    </div>
    <div v-if="currentVendor" class="challenge-selector">
      <Fragment v-for="(c, index) in challengesValues" :key="index">
        <input :checked="index == 0" type="radio" :id="c.vendorId + c.value" name="challenge-tabs" :value="c"
          v-model="activeChallenge" />
        <label class="tab" :for="c.vendorId + c.value">{{ c.value }}</label>
      </Fragment>
      <span class="glider"></span>
    </div>
    <ChallengeRules v-if="currentPhases" :phases="currentPhases" :setCurrentPhase="setCurrentPhase"
      :currentPhase="currentPhase" :currentChallenge="currentChallenge"></ChallengeRules>
    <p class="no-vendors-txt" v-if="!vendors || vendors.length == 0">{{ $t('noEvaluations') }}</p>
  </div>

</template>

<script>
import { Fragment } from 'vue-fragment';
import ChallengeRules from '../../ChallengeRules.vue';

export default {
  components: {
    Fragment,
    ChallengeRules
  },
  props: {
    stepActive: Boolean,
    vendors: Array,
    currentVendor: Object,
    setCurrentVendor: Function,
    currentPhase: Object,
    setCurrentPhase: Function,
    currentChallenge: Object,
    setCurrentChallenge: Function,
    setNextBtnDisabled: Function
  },
  watch: {
    stepActive: function () {
      if (this.stepActive) {
        this.$refs.test_to_take.style.width = "100%";
        this.$refs.test_to_take.style.height = "100%";
        if (!this.currentPhase) {
          this.setNextBtnDisabled(true);
        } else {
          this.setNextBtnDisabled(false);
        }
        return;
      }
      this.$refs.test_to_take.style.width = "0";
      this.$refs.test_to_take.style.height = "0";
    },
    currentVendor: function () {
      if (this.currentVendor && this.stepActive) {
        this.challengesValues = this.currentVendor.challenges.map((c) => {
          return {
            vendorId: this.currentVendor.id,
            value: c.name
          }
        });
        this.activeChallenge = this.challengesValues[0];
        document.documentElement.style.setProperty("--v-glider-width", ((100 / this.challengesValues.length)) + "%");
      } else {
        this.challengesValues = [];
        this.activeChallenge = undefined;
        this.currentPhases = undefined;
      }
    },
    activeChallenge: function () {
      if (this.stepActive) {
        this.setCurrentChallenge(this.currentVendor.challenges.find(c => c.name === this.activeChallenge.value));
        this.$nextTick(() => {
          this.currentPhases = this.currentChallenge.phases;
          this.setCurrentPhase(undefined);
          window.scrollTo(0, document.body.scrollHeight);
        });
      }
    },
    currentPhase: function () {
      if (this.stepActive) {
        this.setNextBtnDisabled(!this.currentPhase);
      }
    }
  },
  data: function () {
    return {
      loading: false,
      challengesValues: [],
      activeChallenge: undefined,
      currentPhases: undefined,
    }
  },
  async created() {
  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style lang="scss">
.test-to-take {
  width: 0%;
  display: flex;
  flex-direction: column;
  transition: width 0.09s ease-in-out;
  overflow: hidden;
  height: 0;

  h6 {
    font-size: 32px;
    font-weight: bold;
    margin-bottom: 10px;
    font-family: "Avenir", sans-serif;
  }

  p {
    font-size: 16px;
    margin-bottom: 40px;
    font-family: "Avenir", sans-serif;
  }

  .markets-container {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr)); // Adjust 200px as needed
    gap: 30px; // Adjust spacing between cards as needed

    @media (max-width: 768px) {
      grid-template-columns: repeat(auto-fill, minmax(106px, 1fr));
      gap: 30px;
    }

    .market-card {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding: 31px 34px;
      min-width: 178px;
      height: 110px;
      background: var(--v-cardBackgroundForLogo-base);
      border-radius: 10px;
      border: 1px solid transparent;
      box-shadow: 5px 5px 20px 0 rgba(0, 0, 0, 0.05);
      transition: box-shadow 0.15s ease-in-out;
      transition: border 0.15s ease-in-out;

      @media (max-width: 768px) {
        border-radius: 50%;
        min-width: unset;
        padding: 0;
      }

      p {
        margin: 0;
      }

      &:hover {
        border: 1px solid #9A9A9A;
        box-shadow: none;
        cursor: pointer;
      }

      &.selected {
        border: 1px solid var(--v-mainGreen-base);
        cursor: pointer;
        box-shadow: none;
      }

      .selected {
        border: 1px solid var(--v-mainGreen-base);
        cursor: pointer;
        box-shadow: none;
      }
    }

    img {
      @media (max-width: 768px) {
        width: 50px;        
      }
    }
  }

  .challenge-selector {
    display: flex;
    position: relative;
    flex-wrap: wrap;
    width: 100%;
    background-color: var(--v-cardHeaderBackground-base);
    border-radius: 10px;
    margin: auto;
    margin-bottom: 40px;
    margin-top: 40px;

    * {
      z-index: 2;
    }

    input[type="radio"] {
      &:checked {
        &+label {
          color: var(--v-mainWhite-base);
        }
      }
    }

    input[type="radio"] {
      display: none;
    }

    input:nth-child(1) {
      &:checked {
        &~.glider {
          transform: translateX(0);
        }
      }
    }

    label {
      i {
        padding-right: 16px;
        font-size: 14px;
      }
    }

    input:nth-child(3) {
      &:checked {
        &~.glider {
          transform: translateX(100%);
        }
      }
    }

    input:nth-child(5) {
      &:checked {
        &~.glider {
          transform: translateX(200%);
        }
      }
    }

    .tab {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
      min-width: 0;
      height: 44px;
      font-size: 16px;
      font-weight: normal;
      color: var(--v-mainBlack-base);
      border-radius: 10px;
      cursor: pointer;
      transition: color 0.15s ease-in;
      font-family: "Avenir", sans-serif;
      font-size: 16px;
      font-weight: bold;
    }

    .glider {
      position: absolute;
      display: flex;
      height: 44px;
      width: var(--v-glider-width);
      background-color: var(--v-mainGreen-base);
      border-radius: 8px;
      z-index: 1;
      transition: 0.25s ease-out;

    }
  }

  .no-vendors-txt {
    font-size: 32px;
    font-weight: bold;
    margin: auto;
    margin-top: 60px;
  }
}
</style>